RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ExportDropdown = Marionette.ItemView.extend({
        template: '#dashboardExportDropdown',
        className: 'dropdown hidden-xs x-export-hide',

        events: {
            'click .x-download-report': 'onDownload',
            'click .x-email-report': 'onEmail',
            'click .x-schedule-report': 'onSchedule'
        },

        templateHelpers: function () {
            const me = this;
            const types = me.model.getExportTypes();

            return {
                hasDownload: _.includes(types, RivalIQ.enums.exportType.DOWNLOAD),
                hasEmail: _.includes(types, RivalIQ.enums.exportType.EMAIL),
                hasSchedule: _.includes(types, RivalIQ.enums.exportType.SCHEDULE)
            };
        },

        serializeData: function () {
            const me = this;

            const exportItems = me.model.getExportFormats();

            return {
                btnClass: me.getOption('btnClass'),
                exportItems: exportItems,
                scheduledExportEnabled: me.scheduledExportEnabled()
            };
        },

        onDownload: function (e) {
            const me = this;
            const format = $(e.currentTarget).data('format');

            // NOTE defer bc ppt export gen can still be slow
            _.defer(function () {
                RivalIQ.export.download(format, me.model);
            });
        },

        onSchedule: function () {
            const me = this;

            RivalIQ.export.schedule(me.model);
        },

        onEmail: function () {
            const me = this;
            RivalIQ.export.email(RivalIQ.export.format.PPT, me.model);
        },

        scheduledExportEnabled: function () {
            const me = this;
            return !me.model.isExportActionDisabled(RivalIQ.enums.exportType.SCHEDULE);
        },

        onShow: function () {
            const me = this;
            me.$el.find('[data-toggle="tooltip"]').tooltip();
        }
    });
});
